module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<form>\n    <div class="form-group userid-input">\n        ';
 if (useEmail) { ;
__p += '\n            <input id="handle" type="text" placeholder="Email" />\n        ';
 } else { ;
__p += '\n            <input id="handle" type="text" placeholder="Email address" value="' +
__e( handle ) +
'" />\n        ';
 } ;
__p += '\n        <span class="help-block error"></span>\n    </div>\n    <div class="user-id-actions">\n        ';
 if (showForgotPassword) { ;
__p += '\n            <a href="#" id="btn-forgot">Forgot password?</a>\n        ';
 } ;
__p += '\n        <button id="btn-next" class="btn btn-primary">Next</button>\n    </div>\n</form>\n';

}
return __p
}